import React, { useState, useEffect } from "react";
import Lottie from "lottie-react";
import { Modal, Button } from "@mui/material";

const BirthdayCelebration = ({ animationData }) => {
  return (
    <div className="flex flex-col items-center justify-center p-4">
      <h2 className="text-xl font-bold">Successfully Submit!</h2>
      <p className="text-lg font-bold">We will reach out to you soon!</p>

      <Lottie animationData={animationData} loop={true} className="w-60 h-60" />
    </div>
  );
};

const BirthdayModal = () => {
  const [open, setOpen] = useState(false);
  const [animationData, setAnimationData] = useState(null);

  // Fetch animation JSON from public folder
  useEffect(() => {
    fetch("/assests/lottie/animation.json")
      .then((res) => res.json())
      .then((data) => setAnimationData(data))
      .catch((err) => console.error("Error loading animation:", err));
  }, []);

  return (
    <div className="flex justify-center">
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Celebrate!
      </Button>
      <Modal open={open} onClose={() => setOpen(false)}>
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm mx-auto mt-20 flex flex-col items-center">
          {animationData ? <BirthdayCelebration animationData={animationData} /> : <p>Loading...</p>}
          <Button variant="contained" color="secondary" fullWidth onClick={() => setOpen(false)}>
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default BirthdayModal;
